module.exports = __webpack_public_path__ + "static/custom-mega-menu-column-break-6519008c169a29eed24add9c8c9e6c3d.png";